// Third party
import React, { useState } from 'react';

// Hooks
import useThemeVersion from '@/hooks/useThemeVersion';

// Utils
import { formatMessage } from '../../../../../utils/i18n';
import { KEY_CODES } from '@/utils/constants';
import Comparison from '@/types/comparison';

type Props = {
  comparison: Comparison;
  setComparisonName: (name: string) => void;
  readOnly?: boolean;
};

const ComparisonTopBarNameMenuItem = ({ comparison, setComparisonName, readOnly }: Props) => {
  const { isLightVersion } = useThemeVersion();
  const DEFAULT_COMPARISON_NAME = formatMessage('Comparison.DefaultName');
  const [isEditing, setIsEditing] = useState(false);
  const [currentName, setCurrentName] = useState(comparison.name || DEFAULT_COMPARISON_NAME);

  const handleNameChange = (name: string) => {
    setCurrentName(name);
  };

  const handleSave = () => {
    let trimmedName = currentName.trim();

    if (!trimmedName) {
      trimmedName = DEFAULT_COMPARISON_NAME;
    }

    setComparisonName(trimmedName);
    setIsEditing(false);
  };

  const handleRenameClick = () => {
    setIsEditing(true);
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === KEY_CODES.ENTER) {
      handleSave();
    } else if (e.key === KEY_CODES.ESCAPE) {
      setCurrentName(comparison.name || DEFAULT_COMPARISON_NAME);
      setIsEditing(false);
    }
  };

  return (
    <div className="comparison-name-menu-item">
      <div className="menu-item-label">{formatMessage('Common.Name')}</div>
      <div className="menu-item-value-container">
        {isEditing ? (
          <input
            type="text"
            className="menu-item-input"
            value={currentName}
            onChange={e => handleNameChange(e.target.value)}
            onBlur={handleSave}
            onKeyDown={handleKeyPress}
            autoFocus
          />
        ) : (
          <>
            <div className="menu-item-value">{comparison.name || DEFAULT_COMPARISON_NAME}</div>
            {!readOnly && (
              <button className="menu-item-action" onClick={handleRenameClick}>
                <i className="icon-pencil" />
                {formatMessage('Common.Rename')}
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ComparisonTopBarNameMenuItem;
